/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import ColorPicker from 'shared/ui/components/form-components/pickers/ColorPicker.vue';
import HorizontalDivider from 'shared/ui/components/HorizontalDivider.vue';
import Switcher from 'shared/ui/components/Switcher.vue';
import CloudStorageFileUploader from 'shared/ui/components/uploader/CloudStorageFileUploader.vue';
import RequestPreview from './RequestPreview.vue';
import OverallAvailabilityPreview from './OverallAvailabilityPreview.vue';

const __vue_script__ = {
    name: 'MeetingRequestThemeForm',

    components: {
        Badge,
        Checkbox,
        ColorPicker,
        HorizontalDivider,
        Switcher,
        RequestPreview,
        OverallAvailabilityPreview,
        CloudStorageFileUploader,
    },

    props: {
        event: {
            type: Object,
            required: true
        },
        theme: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            maxImageFileSize: this.$utils.numbers.parseFileSize('10M'), // backward compatibility, not needed with the updated package
            disabled: false,

            previewTheme: {
                backgroundImageUrl: null,
            },

            chosePreview: 'request_preview',
            previewChoices: [
                { label: this.$t('meetings.requests.settings.preview.meeting_requests'), value: 'request_preview' },
                { label: this.$t('meetings.requests.settings.preview.overall_availability'), value: 'overall_preview' }
            ],

            background_image: null,

            innerValue: {
                assets: this.theme.assets ?? {},
                primary_color: this.theme.primary_color,
                primary_button_text_color: this.theme.primary_button_text_color,
            },
        };
    },

    watch: {
        innerValue: {
            deep: true,
            handler(newValue) {
                this.previewTheme = {
                    ...this.previewTheme,
                    primaryColor: newValue.primary_color,
                    buttonTextColor: newValue.primary_button_text_color,
                };

                this.loadAssetsValues();
            },
            immediate: true
        }
    },

    methods: {
        emit() {
            this.$emit('change', this.innerValue);
        },

        handleSaveClick(isFormInvalid) {
            if (isFormInvalid) {
                this.$emit('invalid');
            }
        },

        onAssetUploaded(asset, doc) {
            this.innerValue.assets[asset] = doc._id;

            this.save();
        },

        onAssetDeleted(asset) {
            this.innerValue.assets[asset] = null;

            this.save();
        },

        save() {
            this.$emit('valid', this.innerValue);
        },

        async loadAssetsValues() {
            const eid = this.event._id;

            for (const [assetType, assetId] of Object.entries(this.innerValue.assets)) {
                if (!assetType) continue;

                const previewKey = `${this.$utils.strings.toCamelCase(assetType)}Url`;

                if (!assetId) {
                    this.previewTheme = {
                        ...this.previewTheme,
                        [previewKey]: null,
                    };
                    this[assetType] = null;
                    continue;
                }

                const doc = await this.$services.documents.getDocById(eid, assetId).catch((error) => {
                    console.error('[MeetingRequestThemeForm] Could not calculate asset path', assetType, error);
                });

                if (!doc) continue;

                const metaNames = this.$utils.attachments.getAttachmentNames(doc);

                this[assetType] = doc;

                this.previewTheme = {
                    ...this.previewTheme,
                    [previewKey]: this.$utils.assets.getEventAttachmentPath(eid, metaNames[0], assetId),
                };
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    attrs: { slim: true },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var handleSubmit = ref.handleSubmit
          var invalid = ref.invalid
          return [
            _c(
              "form",
              {
                staticClass: "meeting-request-theme-form",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.save)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "meeting-request-form" },
                  [
                    _c("div", { staticClass: "intro" }, [
                      _c("div", { staticClass: "secondary" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("meetings.requests.settings.text.intro")
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "panels panels-a" }, [
                      _c(
                        "div",
                        { staticClass: "panel" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "hex_color|required",
                              slim: true,
                              name: "primary_color",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("color-picker", {
                                        attrs: {
                                          name: "primary_color",
                                          label: _vm.$t(
                                            "meetings.requests.settings.colours.primary_bg"
                                          ),
                                          tip: _vm.$t(
                                            "meetings.requests.settings.colours.primary_bg_tip"
                                          ),
                                          errors: errors,
                                        },
                                        on: { input: _vm.emit },
                                        model: {
                                          value: _vm.innerValue.primary_color,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.innerValue,
                                              "primary_color",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "innerValue.primary_color",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "panel" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "hex_color|required",
                              slim: true,
                              name: "primary_button_text_color",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("color-picker", {
                                        attrs: {
                                          name: "primary_button_text_color",
                                          label: _vm.$t(
                                            "meetings.requests.settings.colours.primary_button_text_color"
                                          ),
                                          tip: _vm.$t(
                                            "meetings.requests.settings.colours.primary_button_text_color_tip"
                                          ),
                                          errors: errors,
                                        },
                                        on: { input: _vm.emit },
                                        model: {
                                          value:
                                            _vm.innerValue
                                              .primary_button_text_color,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.innerValue,
                                              "primary_button_text_color",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "innerValue.primary_button_text_color",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "panels panels-a" }),
                    _c("validation-observer", {
                      attrs: { slim: true },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var handleSubmit = ref.handleSubmit
                              var invalid = ref.invalid
                              return [
                                _c(
                                  "form",
                                  {
                                    staticClass: "meeting-request-theme-form",
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return handleSubmit(_vm.save)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "panels panels-a" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "panel" },
                                          [
                                            _c("cloud-storage-file-uploader", {
                                              staticClass: "background",
                                              attrs: {
                                                name: "background",
                                                scope:
                                                  "meeting-request-background",
                                                "fp-type":
                                                  "meeting_request_background_image",
                                                "asset-id":
                                                  "meeting_request_background",
                                                label: _vm.$t(
                                                  "meetings.requests.settings.bg.label"
                                                ),
                                                hint: _vm.$t(
                                                  "meetings.requests.settings.bg.hint"
                                                ),
                                                event: _vm.event,
                                                "max-size":
                                                  _vm.maxImageFileSize,
                                                disabled: _vm.disabled,
                                                multiple: false,
                                              },
                                              on: {
                                                uploaded: function (doc) {
                                                  return _vm.onAssetUploaded(
                                                    "background_image",
                                                    doc
                                                  )
                                                },
                                                deleted: function ($event) {
                                                  return _vm.onAssetDeleted(
                                                    "background_image"
                                                  )
                                                },
                                              },
                                              model: {
                                                value: _vm.background_image,
                                                callback: function ($$v) {
                                                  _vm.background_image = $$v
                                                },
                                                expression: "background_image",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "panel" }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c(
                      "div",
                      { staticClass: "panels panels-a switcher-panel" },
                      [
                        _c("switcher", {
                          attrs: {
                            responsive: true,
                            choices: _vm.previewChoices,
                          },
                          model: {
                            value: _vm.chosePreview,
                            callback: function ($$v) {
                              _vm.chosePreview = $$v
                            },
                            expression: "chosePreview",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "panels panels-a" },
                      [
                        _vm.chosePreview === "request_preview"
                          ? _c("request-preview", {
                              attrs: { theme: _vm.previewTheme },
                            })
                          : _vm._e(),
                        _vm.chosePreview === "overall_preview"
                          ? _c("overall-availability-preview", {
                              attrs: { theme: _vm.previewTheme },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("secondary-toolbar", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.handleSaveClick(invalid)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("general.save")))]
                  ),
                ]),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/meeting-requests/theme/MeetingRequestThemeForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__